import { Waves, Mail, Lock, ArrowRight, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function LoginForm({
  formData,
  setFormData,
  loading,
  msLoading,
  demoLoading,
  error,
  onSubmit,
  onMicrosoftLogin
}) {
  return (
    <>
      {/* Logo and title */}
      <div className="text-center mb-10">
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg shadow-sky-500/25 bg-gradient-to-br from-slate-800 to-slate-900">
            <Waves className="w-7 h-7 text-sky-400" />
          </div>
        </div>
        <h1 className="text-3xl font-heading font-bold text-slate-900 tracking-tight mb-2">
          Velkommen tilbake
        </h1>
        <p className="text-slate-500 text-sm">
          Logg inn på din Microsafe-konto
        </p>
      </div>

      {/* Error message */}
      {error && (
        <div data-testid="login-error-message" className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-start gap-3 animate-fade-in">
          <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-red-700">{error}</p>
        </div>
      )}

      {/* Login form */}
      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <Label className="text-sm font-medium text-slate-700 mb-2 block">E-post</Label>
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 w-4.5 h-4.5 text-slate-400" />
            <Input
              data-testid="login-email-input"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="din.epost@selskap.no"
              className="pl-12 h-12 bg-slate-50 border-transparent focus:bg-white focus:border-sky-500 focus:ring-2 focus:ring-sky-100 rounded-lg transition-all"
              disabled={loading}
            />
          </div>
        </div>

        <div>
          <Label className="text-sm font-medium text-slate-700 mb-2 block">Passord</Label>
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 transform -translate-y-1/2 w-4.5 h-4.5 text-slate-400" />
            <Input
              data-testid="login-password-input"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="........"
              className="pl-12 h-12 bg-slate-50 border-transparent focus:bg-white focus:border-sky-500 focus:ring-2 focus:ring-sky-100 rounded-lg transition-all"
              disabled={loading}
            />
          </div>
        </div>

        <Button
          data-testid="login-submit-button"
          type="submit"
          disabled={loading}
          className="w-full h-12 bg-slate-900 text-white rounded-lg hover:bg-slate-800 hover:scale-[1.02] active:scale-[0.98] transition-all font-medium text-sm mt-2"
        >
          {loading ? (
            <div className="flex items-center justify-center gap-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              <span>Logger inn...</span>
            </div>
          ) : (
            <>
              Logg inn
              <ArrowRight className="ml-2 w-4 h-4" />
            </>
          )}
        </Button>
      </form>

      {/* Help text */}
      <div className="mt-8 pt-6 border-t border-slate-100 text-center">
        <p className="text-sm text-slate-500">
          Trenger du tilgang?{' '}
          <a href="mailto:kontakt@microsafe.no" className="text-sky-500 hover:text-sky-600 font-medium transition-colors">
            Kontakt oss
          </a>
        </p>
      </div>
    </>
  );
}
